<template>
  <modal :visible="$props.visible"
         :close-visible="false"
         prevent-backdrop-close
         @modal-close="$emit('close')">
    <div slot="body" class="buyout-body">
      <img src="/assets/images/cart_replace.svg" class="dialog-icon" width="77" alt="">
      <h2 class="title">{{ $t('checkout.cartOverview.buyoutTitle') }}</h2>
      <p class="description">{{ $t('checkout.cartOverview.buyoutDescription') }}</p>
      <div class="label-section">
        <p class="buyout-label">{{ $t('checkout.cartOverview.buyoutPriceLabel') }}</p>
        <p class="buyout-price">{{ $props.buyoutData }} <span class="currency">{{ $t('common.currency') }}</span></p>
      </div>
      <div class="actions-section">
        <base-button class="action-button"
                     :loading="dataLoading"
                     @click="$emit('continue')">
          {{ $t('common.continueShopping') }}
        </base-button>
        <base-button variant="secondary"
                     class="action-button"
                     @click="$emit('cancel')">
          {{ $t('common.abort') }}
        </base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../common/modal/modal'
import BaseButton from '../../base/base-button'

export default {
  name: 'buyout-dialog',
  components: { Modal, BaseButton },
  data () {
    return {
      dataLoading: false
    }
  },
  props: {
    visible: Boolean,
    buyoutData: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.buyout-body {
  text-align: center;
  color: $text;
  padding: 3.2rem;

  .dialog-icon {
    width: 77px;
    height: auto;
    margin-bottom: 2.4rem;
  }

  .title {
    font-size: 2.4rem;
    font-weight: normal;
    margin-bottom: 1.6rem;
  }

  .description {
    font-size: 1.6rem;
    color: $dark-grey;
    margin-bottom: 3.2rem;
  }

  .label-section {
    width: auto;
    margin: auto;
    text-align: left;
    background-color: $grey;
    border-radius: 0.5rem;
    padding: 2.2rem 4rem;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (map_get($breakpoints, sm)) {
      max-width: 31rem;
    }

    .buyout-label {
      font-size: 1.2rem;
      margin: 0;
      color: $dark-grey;
      white-space: nowrap;
    }

    .buyout-price {
      font-size: 2rem;
      font-weight: 600;
      margin: 0 0 0 1.6rem;
      color: $primary;
      white-space: nowrap;
    }

    .currency {
      font-size: 1.4rem;
      color: $text;
    }
  }

  .actions-section {
    text-align: center;
    margin-top: 4rem;

    .action-button {
      width: 100%;
      margin: 0.8rem 0;

      @media (map_get($breakpoints, sm)) {
        margin: 0 1.6rem;
        max-width: 24rem;
      }
    }
  }
}
</style>
